import { render, staticRenderFns } from "./InviteStatus.vue?vue&type=template&id=f9883e28&"
import script from "./InviteStatus.vue?vue&type=script&lang=js&"
export * from "./InviteStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports